export var AuthProfileType = /*#__PURE__*/ function(AuthProfileType) {
    AuthProfileType["VendorAdmin"] = "VendorAdmin";
    AuthProfileType["ServiceAccount"] = "ServiceAccount";
    AuthProfileType["AccountManager"] = "AccountManager";
    AuthProfileType["HiringManager"] = "HiringManager";
    AuthProfileType["ResourceManager"] = "ResourceManager";
    AuthProfileType["Recruiter"] = "Recruiter";
    AuthProfileType["Contractor"] = "Contractor";
    AuthProfileType["ClientService"] = "ClientService";
    AuthProfileType["AppSupport"] = "AppSupport";
    AuthProfileType["Marketer"] = "Marketer";
    AuthProfileType["Subvendor"] = "Subvendor";
    AuthProfileType["GorillaResumeUser"] = "GorillaResumeUser";
    AuthProfileType["GorillaResumeAdmin"] = "GorillaResumeAdmin";
    return AuthProfileType;
}({});
export var AuthSignupType = /*#__PURE__*/ function(AuthSignupType) {
    AuthSignupType["Email"] = "email";
    AuthSignupType["Social"] = "social";
    return AuthSignupType;
}({});
export var FboProfileTypeId = /*#__PURE__*/ function(FboProfileTypeId) {
    FboProfileTypeId[FboProfileTypeId["Organizational"] = 1] = "Organizational";
    FboProfileTypeId[FboProfileTypeId["Temp"] = 3] = "Temp";
    FboProfileTypeId[FboProfileTypeId["CanadianSP"] = 4] = "CanadianSP";
    FboProfileTypeId[FboProfileTypeId["IncWorker"] = 5] = "IncWorker";
    FboProfileTypeId[FboProfileTypeId["SubvendorWorker"] = 6] = "SubvendorWorker";
    FboProfileTypeId[FboProfileTypeId["W2Worker"] = 7] = "W2Worker";
    FboProfileTypeId[FboProfileTypeId["USIncWokrer"] = 8] = "USIncWokrer";
    return FboProfileTypeId;
}({});
export var FboUrlTypeId = /*#__PURE__*/ function(FboUrlTypeId) {
    FboUrlTypeId[FboUrlTypeId["TimesheetDetail"] = 1] = "TimesheetDetail";
    FboUrlTypeId[FboUrlTypeId["ExpenseDetail"] = 2] = "ExpenseDetail";
    FboUrlTypeId[FboUrlTypeId["CreateExpense"] = 3] = "CreateExpense";
    return FboUrlTypeId;
}({});
export var DomainDetectionErrors = /*#__PURE__*/ function(DomainDetectionErrors) {
    DomainDetectionErrors["ClientSignupNotAllowed"] = "ClientSignupNotAllowed";
    DomainDetectionErrors["ClientCreateNotAllowed"] = "ClientCreateNotAllowed";
    return DomainDetectionErrors;
}({});
